module.exports = __webpack_public_path__ + "img/JohnAbel@2x.e8a1f4ab.png";